export enum ExtendServicePath {
  AOS = '/aos',
  ASOR_INTERNAL = '/asorInternal',
  APPHUB = '/apphub',
  OCTOPAAS = '/auth',
  TEZCA_STATE = '/orchestrate/insights',
  ROBOT = '',
  OBSERVABILITY = '/observability',
}

export enum ExtendSubdomainService {
  ANALYTICS = 'analytics',
  ORCH_BUILDER = 'orchestrate',
  DEVTOOLS_SERVER = 'api',
  APP_PREVIEW = 'apppreview',
  /** Local Session App Preview subdomain (local.apppreview.*). */
  LOCAL_APP_PREVIEW = 'local.apppreview',
  STUDIOBUILDER = 'studiobuilder',
}

export const apiPath = '/api';

export const subdomainApiPath = '/sub-api';

export const gatewayApiPath = '/gateway';
